const estadoConfig = {
  pendiente: {
    color: "bg-red",
    icon: "fas fa-warning fa-fw",
    texto: "PENDIENTE DE PAGO",
    tooltip: "Este comprobante aún no ha sido cancelado",
  },
  pagada: {
    color: "bg-green",
    icon: "fas fa-square-check fa-fw",
    texto: "PAGADA",
    tooltip: "El comprobante ha sido pagado",
  },
  anulada: {
    color: "bg-danger",
    icon: "fas fa-ban fa-fw",
    texto: "ANULADA",
    tooltip: "Documento anulado oficialmente",
  },
  invalidada: {
    color: "bg-warning",
    icon: "fas fa-ban fa-fw",
    texto: "DOCUMENTO INVALIDADO",
    tooltip: "El documento fue invalidado por la administración tributaria",
  },
  aplicada: {
    color: "bg-green",
    icon: "fas fa-square-check fa-fw",
    texto: "APLICADA",
    tooltip: "Esta nota fue aplicada al comprobante relacionado",
  },
  abierto: {
    color: "bg-warning",
    icon: "fas fa-warning fa-fw",
    texto: "EVENTO ACTIVO",
    tooltip: "El estado de este elemento esta abierto",
  },
  cerrado: {
    color: "bg-green",
    icon: "fas fa-circle-check fa-fw",
    texto: "CERRADO",
    tooltip: "El estado de este elemento esta cerrado",
  },
};

const StatusBadge = ({ estado, size = "fs-5", showTooltip = true }) => {
  const config = estadoConfig[estado];
  if (!config) return null;

  return (
    <span className={`badge ${config.color} me-1 ${size}`} title={showTooltip ? config.tooltip : undefined}>
      <i className={config.icon}></i> {config.texto}
    </span>
  );
};

export default StatusBadge;
